export enum BUTTON_VARIANTS {
    Primary = 'primary',
    PrimaryAccent = 'primary-accent',
    Default = 'default',
    Secondary = 'secondary',
    Tertiary = 'tertiary',
    Transparent = 'transparent',
    Dismiss = 'dismiss',
    Text = 'text'
}
